import { ENROLLMENT_SUPPORT_PHONE } from '@/features/enrollment/constants/enrollmentContent'

export function EnrollmentHelpText() {
  return (
    <p className="mt-2 text-center text-[14px] text-[#1f1f1f]">
      If you need help or see any incorrect data, please call{' '}
      <a
        href={ENROLLMENT_SUPPORT_PHONE.href}
        className="font-semibold text-primary transition-colors hover:text-primary-hover"
      >
        {ENROLLMENT_SUPPORT_PHONE.display}
      </a>
    </p>
  )
}
